import { Component } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import {  MatSelectChange } from '@angular/material/select';
import { MatSort } from '@angular/material/sort';
import {  MatTableDataSource } from '@angular/material/table';
import { ExcelService } from 'src/app/shared/excel';
import { combineLatest } from 'rxjs';
import { ColumnSetting } from 'src/app/layout/table-standard-layout/table-standard-layout.component';
import { map, switchMap } from 'rxjs/operators';
import moment from 'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { Moment } from 'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

@Component({
  selector: 'app-transaction-view',
  templateUrl: './transaction-view.component.html',
  styleUrls: ['./transaction-view.component.css']
})
export class TransactionViewComponent {

  // transactions$;
  inputDateFrom: Date;
  inputDateTo: Date;
  timeSelected: string = "";

 
  constructor(private router:Router,
    private route: ActivatedRoute,) {

  }


  onSubmit(form) {
    // console.log(form)

    
    // console.log("from", moment( this.inputDateFrom.valueOf()))
    // console.log("to", moment(this.inputDateTo.valueOf()))
    // console.log("from unix", moment(this.inputDateFrom.valueOf()).unix())
    // console.log("to unix", moment(this.inputDateTo.valueOf()).unix())

    // console.log("Serch date:", moment(this.inputDateFrom).tz("America/Los_Angeles").format());
    this.router.navigate(['generate'], {
      queryParams:
      {
        dateFrom: moment(this.inputDateFrom.valueOf()).unix(),
        dateTo: moment(this.inputDateTo.valueOf()).unix(),
      }, relativeTo: this.route
    })
    
  }

  setTimePeriodeEvent(event: MatSelectChange) {
    this.setTimePeriode(event.value);
  }

  setTimePeriode(value) {
    try {

      const now = moment();

      let from: Moment;
      let to: Moment;
      console.log(value)
      switch (value) {
        case 'TODAY':
          from = moment(now).startOf('day');
          to = now.endOf('day');
          break;
        case 'YESTERDAY':
          from = moment(now).subtract(1, 'days').startOf('day');
          to = moment(from).endOf('day');
          break;
        case '24H':
            from = moment(now).subtract(1, 'days');
            to = moment(now);
          break;
        case 'THIS_MONTH':
            from = moment(now).startOf('month');
            to = moment(now).endOf('day');
          break;
        case 'LAST_MONTH':
            from = moment(now).subtract(1, 'month').startOf('month');
            to = moment(from).endOf('month');
          break;
        case 'CUSTOM':
          return;
          break;
        default:
          throw new Error("Unhandled select time case!")
      }

      this.inputDateFrom = from.toDate();
      this.inputDateTo = to.toDate();

      console.log("from", this.inputDateFrom)
      console.log("to", this.inputDateTo)

    } catch (err) {
      console.log(err.message)
    }

  }


  setCustomRange(event: MatDatepickerInputEvent<Date>, picker: 'start' | 'end') {

    if (picker === 'start') {
      this.inputDateFrom = moment(event.value).startOf('day').toDate();
    } else {
      this.inputDateTo = moment(event.value).endOf('day').toDate()
    }
  }
}
